import { render, staticRenderFns } from "./BankDetailInfo.vue?vue&type=template&id=230e159a&scoped=true&"
import script from "./BankDetailInfo.vue?vue&type=script&lang=js&"
export * from "./BankDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./BankDetailInfo.vue?vue&type=style&index=0&id=230e159a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e159a",
  null
  
)

export default component.exports